// extracted by mini-css-extract-plugin
export var createdDate = "_hk-1";
export var divider = "_hk-2";
export var headerDivider = "_hk-3";
export var messagesCard = "_hk-0";
export var messagesContainer = "_hk-7";
export var messagesContainerWrapper = "_hk-4";
export var pointerCapturingButtonBoxes = "_hk-a";
export var showLeftPanelButton = "_hk-9";
export var showMoreButton = "_hk-c";
export var showMoreButtonContainer = "_hk-b";
export var summaryTitle = "_hk-6";
export var systemMessageCardWrapper = "_hk-d";
export var topButtons = "_hk-8";
export var withPadding = "_hk-5";